<template>
    <div class="card-group mb-4">
        <div class="card box mr-2" style="border: 0">
            <div class="box-header">
                <h5>Avaiable properties for product of category</h5>
                <small class="text-muted mb-2">//Drag and drop to choose properties</small>
            </div>
            <div class="box-content">
                <draggable class="list-group" tag="ul" v-model="avaiableProperties" v-bind="dragOptions" @start="isDragging=true" @end="isDragging=false">
                    <transition-group type="transition" :name="'flip-list'">
                        <li class="list-group-item text-capitalize" v-for="(property, index) in avaiableProperties" :key="property.id">
                            {{property.name.replace('_', ' ')}}
                            <small class="text-muted text-lowercase">//{{ property.type == 1 ? 'short text' : property.type == 2 ? 'long text' : 'editor'}}</small>
                        </li>
                    </transition-group>
                </draggable>
            </div>
        </div>
        <div class="card box ml-2" style="border: 0">
            <div class="box-header">
                <h5>Properties of this category product</h5>
                <small class="text-muted mb-2">//Drag and drop to removed or sort properties from the 9th item</small>
            </div>
            <div class="box-content">
                <ol class="list-group must-have">
                    <li class="list-group-item text-capitalize" v-for="(property, index) in MUST_HAVE_PROPERTIES" :key="property.id">
                        <span class="badge badge-pill badge-primary p-2">{{index + 1}}</span>
                        {{property.name.replace('_', ' ')}}
                        <small class="text-muted text-lowercase">//{{ property.type == 1 ? 'short text' : property.type == 2 ? 'long text' : 'editor'}}</small>
                    </li>
                </ol>
                <draggable element="span" v-model="productProperties" v-bind="dragOptions">
                    <transition-group name="no" class="list-group" tag="ol">
                        <li class="list-group-item text-capitalize" v-for="(property, index) in productProperties" :key="property.id">
                            <span class="badge badge-pill badge-primary p-2">{{index + MUST_HAVE_PROPERTIES.length + 1}}</span>
                            {{property.name.replace('_', ' ')}}
                            <small class="text-muted text-lowercase">//{{ property.type == 1 ? 'short text' : property.type == 2 ? 'long text' : 'editor'}}</small>
                        </li>
                    </transition-group>
                </draggable>
            </div>
        </div>
        <input type="hidden" :value="JSON.stringify(productProperties)" name="product_properties"/>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
export default {
    props: ['pAvaiableProperties', 'pProductProperties'],
    data() {
        return {
            MUST_HAVE_PROPERTIES: [
                { 'name': 'Title', 'type': 1, 'id': 8999},
                { 'name': 'Key word', 'type': 2, 'id': 9001}, 
                { 'name': 'Description', 'type': 3, 'id': 9002}, 
                { 'name': 'Kin', 'type': 2, 'id': 9003}, 
                { 'name': 'Meta Title', 'type': 2, 'id': 9004}, 
                { 'name': 'Meta Description', 'type': 2, 'id': 9005}, 
                { 'name': 'Meta Keywords', 'type': 2, 'id': 9006}
            ],
            avaiableProperties: this.pAvaiableProperties,
            productProperties: this.pProductProperties,
            isDragging: false,
            delayedDragging: false
        };
    },
    computed: {
        dragOptions() {
            return {
                animation: 0,
                group: "description",
                ghostClass: "ghost"
            };
        }
    },
    watch: {
        isDragging(newValue) {
            if (newValue) {
                this.delayedDragging = true;
                return;
            }
            this.$nextTick(() => {
                this.delayedDragging = false;
            });
        }
    },
    mounted() {
    }
}
</script>
<style>
    .flip-list-move {
      transition: transform 0.5s;
    }
    .no-move {
      transition: transform 0s;
    }
    .ghost {
      opacity: 0.5;
      background: #e2edfb;
    }
    .list-group {
      min-height: 20px;
    }
    .list-group.must-have li {
        background: #e2e2e2;
    }
    .list-group.must-have li:last-child {
        border-bottom: 0px;
    }
    .list-group-item {
      cursor: move;
    }
    .list-group-item i {
      cursor: pointer;
    }
</style>
